import { useState } from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from '@mui/material';
import { useQuery } from 'react-query';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useNotification from 'hooks/useNotification';

/**
 * Xodimga biriktirilgan lidlarni Excel'ga eksport qilish oynasi.
 * Sana oralig'i + xodim tanlanadi → backend event tarixidan biriktirilgan
 * barcha lidlarni qaytaradi (Birikkan vaqti | Varonka | Lid | Kontakt | Tel).
 */
const CRMStaffLeadsExportModal = ({ open, setOpen }) => {
  const axiosPrivate = useAxiosPrivate();
  const sendNotification = useNotification();

  const [staff, setStaff] = useState('');
  const [from, setFrom] = useState('');
  const [till, setTill] = useState('');
  const [exporting, setExporting] = useState(false);

  const { data: staffes } = useQuery({
    queryKey: ['/dictionary/staffes'],
    queryFn: async () =>
      (await axiosPrivate.get('/dictionary/staffes')).data?.data,
    enabled: open,
    retry: false,
  });

  const onClose = () => {
    if (exporting) return;
    setOpen(false);
  };

  const onExport = async () => {
    if (!staff) {
      sendNotification({ msg: 'Xodimni tanlang', variant: 'warning' });
      return;
    }
    setExporting(true);
    try {
      const params = new URLSearchParams({ staff });
      if (from) params.set('from', from);
      if (till) params.set('till', till);

      const res = await axiosPrivate.get(
        `/crm/excel/staffleads?${params.toString()}`,
        { responseType: 'blob' },
      );
      const blob = new Blob([res.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const cd = res?.headers?.['content-disposition'] || '';
      const match = cd.match(/filename="?([^"]+)"?/);
      const filename = match ? match[1] : `Xodim-lidlari-${Date.now()}.xlsx`;

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      sendNotification({ msg: 'Excel yuklab olindi', variant: 'success' });
      setOpen(false);
    } catch (e) {
      sendNotification({
        msg: `Eksport xatosi${
          e?.response?.status ? ' (' + e.response.status + ')' : ''
        }`,
        variant: 'error',
      });
    } finally {
      setExporting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
      <DialogTitle>Xodim lidlarini yuklab olish</DialogTitle>
      <DialogContent>
        <div className='flex flex-col gap-4 pt-2'>
          <TextField
            select
            size='small'
            label='Xodim'
            value={staff}
            onChange={(e) => setStaff(e.target.value)}
            fullWidth
          >
            {(staffes || []).map((s) => (
              <MenuItem key={s.id} value={s.id}>
                {s.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            type='date'
            size='small'
            label='Dan'
            value={from}
            onChange={(e) => setFrom(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
          <TextField
            type='date'
            size='small'
            label='Gacha'
            value={till}
            onChange={(e) => setTill(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant='base' disabled={exporting} onClick={onClose}>
          Bekor qilish
        </Button>
        <Button
          variant='contained'
          color='success'
          disabled={exporting || !staff}
          startIcon={
            exporting ? (
              <CircularProgress size={14} color='inherit' />
            ) : (
              <i className='bi bi-download' />
            )
          }
          onClick={onExport}
        >
          Yuklab olish
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CRMStaffLeadsExportModal;
